import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('MEDIAS').plugin(axiosPlugin, {template: "array"});

let fetchMediasAction = redux.fetchActionGet();

redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state, lastUpdate : Date.now()};
    payload.data.forEach(media => {
        newState.data.unshift(media);
        newState.total++;
    });
    return newState;
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state, lastUpdate : Date.now()};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});

// redux.reducerForType('ADD_LIKE', (state,payload) => {
//     let newState = {...state};
//     newState.data = newState.data.map(item =>{
//         if(item._id.toString() === payload.data.parentId.toString()){
//             item.count.like++;
//             item.isLiked = true;
//         }
//         return item;
//     });
//     return newState;
// });
//
// redux.reducerForType('DELETE_LIKE', (state,payload) => {
//     let newState = {...state};
//     newState.data = newState.data.map(item =>{
//         if(item._id.toString() === payload.data.parentId.toString()){
//             item.count.like--;
//             item.isLiked = false;
//             if(item.count.like < 0){
//                 item.count.like = 0;
//             }
//         }
//         return item;
//     });
//     return newState;
// });

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state, lastUpdate : Date.now()};
    if(payload.data && payload.data._id){
        newState.data = newState.data.map(item => {
            if(item._id.toString() === payload.data._id.toString()){
                item = payload.data;
            }
            return item;
        });
    }
    return newState;
});

export const fetchMedias = (query = {}) => {
    let sort = ['-createdAt', '-count.like', '-count.like', '-count.like', '-count.comment'];
    query = {...query, sort: sort[query.sort] || sort[0]};
    return fetchMediasAction(`/medias?${queryString.stringify(query)}`)
};
export const TYPES = redux.types;

export const resetMedias = () => redux.actions.reset();

export const medias = redux.reducer();